<template>
  <div>
    <table-view
      ref="tableList"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      tableCardTitle="Country Risk Report"
    >
      <template v-slot:action>
        <a
          href="javascript:void (0)"
          class="icon-view1"
          style="color: #3a3f63; font-size: 20px"
          @click="$router.push('/reports/country-risk-analysis-report/detail')"
        ></a>
      </template>
    </table-view>
  </div>
</template>

<script>
export default {
  data() {
    const tableModel = [
      {
        label: 'Report Type',
        prop: 'typeStr',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'Submitted By',
        prop: 'username',
      },
      {
        label: 'Status',
        prop: 'statusStr',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]
    return {
      tableModel,
      tableData: [
        {
          id: '1542791600329035778',
          typeStr: 'Brazil Report',
          statusStr: 'Success',
          username: 'liujd2',
          createTime: '2022-07-01 16:45:56',
        },
      ],
      pages: {
        current: 1,
        size: 10,
        total: 1,
      },
    }
  },
}
</script>
